import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useRegisterFocus } from '../../../FocusZone';
export const ExternalLink = ({ id, className, style, to, hash, onClick, onRenderExternal, onMouseEnter, onMouseLeave, children, }) => {
    const ref = useRef(null);
    useRegisterFocus(ref);
    return (_jsx("a", Object.assign({ id: id, ref: ref, className: className, style: style, href: to, rel: "noreferrer noopener", target: "_blank", onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: onRenderExternal === undefined ? children : onRenderExternal(children) }), void 0));
};
//# sourceMappingURL=ExternalLink.js.map